(function (Drupal, once) {
  Drupal.behaviors.registerForm = {
    attach: (context, settings) => {
      // Registration page
      once('registerForm','.user-register-form', context).forEach((form) => {
        const regForm = context.querySelector('.user-register-form');
        const mailDiv = context.querySelector('#qd_mail');
        const profileIsOver13 = regForm.querySelector('#edit-is-over13-profiles-0');
        profileIsOver13.prepend(mailDiv);
        clean(regForm);

        const submitBtn = context.querySelector('input#edit-submit');
        submitBtn.addEventListener('click', function() {
          jsValidatenewuser();
        });


        const year = regForm.querySelector('#edit-birthday-profiles-0-entity-field-birthday-year');
        year.addEventListener('change', (event) => {
          calculateAge.bind(regForm)();
        });

        const month = regForm.querySelector('#edit-birthday-profiles-0-entity-field-birthday-month');
        month.addEventListener('change', (event) => {
          calculateAge.bind(regForm)();
        });

        function calculateAge() {
          let birthYear = parseInt(year.value);
          let birthMonth = parseInt(month.value);
          if (isNaN(birthYear) || isNaN(birthMonth)) return;
          let today = new Date();
          let birthDate = new Date(birthYear, birthMonth, 1);
          let years = Math.floor((today.getTime() - birthDate.getTime()) / (1000 * 365.25 * 60 * 60 * 24));
          if (years > 13) {
            profileIsOver13.classList.add('render');
            //regForm.querySelector('#edit-field-mailchimp').classList.add('render');
          } else {
            profileIsOver13.classList.remove('render');
            //regForm.querySelector('#edit-field-mailchimp').classList.remove('render');
          }
        }

        function clean(item) {
          let itemChildren = item.children;
          // clear error styling
          item.removeAttribute('style');
          // clear anon email
          Array.from(itemChildren).forEach((child) => {
            clean(child);
            if (child.tagName === 'INPUT') {
              if (child.type === 'email') {
                if (child.value.startsWith('anon')) {
                  // @TODO this isn't having an effect
                  child.value = '';
                }
              }
            }
          });
        }

        function stdError() {
          let errorMsgs = context.querySelector('.error.messages');
          if (errorMsgs) {
            let text = errorMsgs.innerHTML.replace(/\s+/gim, '');
            if (text.length > 0) {
              return;
            }
            errorMsgs.innerHTML = 'Please complete all fields below.';
          }
        }

        function jsValidatenewuser(e) {
          let strMsg='';
          let uname = document.getElementById('edit-name');
          let pass = document.getElementById('edit-pass-pass1');
          let cnfpass = document.getElementById('edit-pass-pass2');
          let secQ = document.getElementById('edit-birthday-profiles-0-entity-field-choose-a-security');
          let secAns = document.getElementById('edit-birthday-profiles-0-entity-field-question-0-value');
          let birthMonth = document.getElementById('edit-birthday-profiles-0-entity-field-birthday-month');
          let birthYear = document.getElementById('edit-birthday-profiles-0-entity-field-birthday-year');

          if(thisHasProfanity(uname.value)) {
            uname.value='';
            strMsg += 'profane';
            document.getElementById("profane_text").style.display = 'table';
          } else {
            document.getElementById("profane_text").style.display = 'none';
          }

          if (uname.value=='' || uname.value==' ') {
            strMsg += 'uname';
            uname.style.border='1px solid red';
            stdError();
          }
          else {
            strMsg += '';
            uname.style.border='0px';
          }

          if(document.getElementById('edit-pass-pass1').value != document.getElementById('edit-pass-pass2').value) {
            strMsg += 'not_match'
            document.getElementById('edit-pass-pass2').style.border="1px solid red";
            document.getElementById("email_match").style.display = 'table';
            stdError();
          }
          else {
            strMsg += ""
            document.getElementById('edit-pass-pass2').style.border="0px";
          }

          if (pass.value=='' || pass.value==' ') {
            strMsg += "pass";
            pass.style.border='1px solid red';
            stdError();
          }
          else {
            strMsg += "";
            pass.style.border='0px';
          }

          if (cnfpass.value=='' || cnfpass.value==' ') {
            strMsg += 'cnfpass';
            cnfpass.style.border='1px solid red';
            stdError();
          }
          else {
            strMsg += "";
            cnfpass.style.border='0px';
          }

          if (secAns.value=='' || secAns.value==' ') {
            strMsg += 'ans';
            secAns.style.border='1px solid red';
            stdError();
          }
          else {
            strMsg += '';
            secAns.style.border='0px';
          }

          if (birthYear.value=='_none' || birthYear.value=='_none') {
            strMsg += 'bday_y';
            birthYear.style.border='1px solid red';
            stdError();
          }
          else {
            strMsg += '';
            birthYear.style.border='0px';
          }

          if (birthMonth.value=='_none' || birthMonth.value=='_none') {
            strMsg += 'bday_m';
            birthMonth.style.border='1px solid red';
            stdError();
          }
          else {
            strMsg += '';
            birthMonth.style.border='0px';
          }

          if (secQ.value=='_none' || secQ.value=='_none') {
            strMsg += 'bday_m';
            secQ.style.border='1px solid red';
            stdError();
          }
          else {
            strMsg += '';
            secQ.style.border='0px';
          }

          if(strMsg == '') {
            console.log('strMsg empty');
            gtag('event', 'conversion', {'send_to': 'AW-826410768/v_5yCNOL13oQkI6IigM',  'event_callback': function(){
              console.log('gtag event triggered');
              if(!document.querySelector('#edit-is-over13-profiles-0').classList.contains('render')) {
                console.log('over13');
                let randomUser = Math.round(Math.random() * 10000000000);
                anonMail = 'anonuser'+randomUser+'@quandary.org';
                document.getElementById('edit-mail').value = anonMail;
                document.getElementById('edit-is-over13-profiles-0-entity-field-confirm-email-0-value').value = anonMail;
                setTimeout(function(){
                  regForm.submit();
                },5);
                return;
              }
              else {
                regForm.submit();
              }
            }});
          }
          else {
            document.getElementById("all_fields").style.display = 'table';
          }

        }

        function thisHasProfanity(s) {
          let PROFANITY = ['asses','asshole','asskisser','asswipe','balls','bastard','beastial','beaver','bitch','blow job','blowjob','boner','brown eye','browneye','browntown','bucket cunt','bung hole','butt','butt breath','butt hair','buttface','butthead','butthole','buttpicker','chink','circle jerk','clit','cobia','cock','cooter','crap','cummer','cumming','cums','cumshot','cunilingus','cunillingus','cunnilingus','cunt','cyberfuc','damn','dick','dike','dildo','dink','dong','douche','dumbass','dyke','ejaculate','ejaculating','ejaculation','fag','fart','fatass','fatso','felatio','fellatio','fuck','fuk','furburger','gangbang','gaysex','gazongers','goddamn','gonads','gook','guinne','hard on','hardon','hardcoresex','homo','hooker','horniest','horny','hussy','jack off','jackass','jacking off','jackoff','jack-off','jerk','jism','jiz','jizm','jizz','kike','kock','kondum','kraut','kunilingus','lesbian','lesbo','merde','muff','nigger','orgasim','orgasm','pecker','penis','phuk','phuq','pimp','piss','prick','pussies','pussy','queer','retard','schlong','sex','sheister','shit','slag','sleaze','slut','smut','snatch','spunk','twat','whacker','wetback','whore','wop'];

          let hasWord = false;
          for(i=0; i < PROFANITY.length; i++) {
            if(s.indexOf(PROFANITY[i]) != -1) {
              hasWord = true;

            }
          }

          return hasWord;
        }
      });
    },
  };

  Drupal.behaviors.loginForm = {
    attach: (context, settings) => {
      // Registration page
      once('loginForm','.user-login-form', context).forEach((form) => {
        const loginForm = context.querySelector('.user-login-form');
        const action = loginForm.getAttribute('action').replace('?destination=/sign-in%3F', '?');
        loginForm.setAttribute('action', action);
      });
    },
  };
})(Drupal, once);
